import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { download, printPDF } from '../../../_helper/file.helper';

/**
 * A generic configurable dialog used to display and download pdfs.
 */
@Component({
    template: `
    <div class="iframe-container">
      <div class="iframe-toolbar">
        <div class="iframe-name">{{data.fileName}}</div>
        <div class="iframe-sub-toolbar">
          <div class="iframe-button" matRipple matRippleColor="rgba(255, 255, 255, 0.1)" (click)="download()">
            <mat-icon class="iframe-button-icon">download</mat-icon><span class="hide-tablet">&nbsp;Download</span>
          </div>
          <div *ngIf="isPDF" class="iframe-button" matRipple matRippleColor="rgba(255, 255, 255, 0.1)" (click)="print()">
            <mat-icon class="iframe-button-icon">print</mat-icon><span class="hide-tablet">&nbsp;Print</span>
          </div>
          <mat-icon class="iframe-close" matRipple matRippleColor="rgba(255, 255, 255, 0.1)" (click)="close()">
            close
          </mat-icon>
        </div>
      </div>
      <div class="iframe-wrapper">
        <iframe *ngIf="loaded" width="100%" height="100%" style="border:0" [src]="url"
                [id]="data.fileName + data.fileExtension"
                [name]="data.fileName + data.fileExtension">
        </iframe>
      </div>
    </div>
  `,
    styleUrls: ['./_dialog.scss'],
    standalone: false
})
export class IframeDialog implements OnInit, OnDestroy {

  public loaded: boolean = false;
  private unsafeUrl: string = null;
  public url: SafeResourceUrl = null;

  public get isPDF(): boolean {
    return this.data.blob.type === 'application/pdf' ||
            this.data.fileExtension === '.pdf' ||
            this.data.fileName.endsWith('.pdf');
  }

  constructor(
    private self: MatDialogRef<IframeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      fileName: string;
      fileExtension: string;
      blob: Blob;
    },
    private sanitizer: DomSanitizer
  ) { }

  public ngOnInit() {
    this.loaded = false;
    this.unsafeUrl = window.URL.createObjectURL(this.data.blob);
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.unsafeUrl);
    this.loaded = true;
  }

  public ngOnDestroy() {
    window.URL.revokeObjectURL(this.unsafeUrl);
  }

  public download() {
    download(this.data.fileName + this.data.fileExtension, this.data.blob);
  }

  public print() {
    printPDF(this.data.fileName + this.data.fileExtension, this.data.blob);
  }

  public close() {
    this.self.close();
  }
}

export const IframeDialogConfig = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  maxHeight: '100vh',
  panelClass: 'fullscreen-dialog'
}
